import { useInsightsSectionContent } from './useInsightsSectionContent';
import { parseInsightsHeroContent } from '../utils/insightsContent';

export const useInsightsHeroContent = () =>
  useInsightsSectionContent(parseInsightsHeroContent);
